var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGlasses(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.46,4.75c-.84,0-1.51,.68-1.51,1.51s.68,1.51,1.51,1.51c5.21,0,9.45,4.24,9.45,9.45v21.43c-2.29-2.66-5.68-4.36-9.45-4.36-5.34,0-9.89,3.38-11.67,8.11-.87-.62-1.93-.99-3.08-.99s-2.24,.38-3.11,1.01c-1.77-4.74-6.33-8.13-11.69-8.13-3.78,0-7.16,1.7-9.45,4.36V17.22c0-5.21,4.24-9.45,9.45-9.45,.84,0,1.51-.68,1.51-1.51s-.68-1.51-1.51-1.51c-6.88,0-12.48,5.6-12.48,12.48v29.55c0,6.88,5.6,12.48,12.48,12.48s12.48-5.6,12.48-12.48c0-1.28,1.04-2.32,2.32-2.32s2.27,1.04,2.27,2.32c0,6.88,5.6,12.48,12.48,12.48s12.48-5.6,12.48-12.48V17.22c0-6.88-5.6-12.48-12.48-12.48h0ZM16.91,56.23c-5.21,0-9.45-4.24-9.45-9.45s4.24-9.45,9.45-9.45,9.45,4.24,9.45,9.45c-.01,5.21-4.25,9.45-9.45,9.45Zm29.55,0c-5.21,0-9.45-4.24-9.45-9.45s4.24-9.45,9.45-9.45,9.45,4.24,9.45,9.45-4.24,9.45-9.45,9.45Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGlasses);
export default __webpack_public_path__ + "static/media/icon_glasses.a323f97a.svg";
export { ForwardRef as ReactComponent };